<template>
  <v-card
    class="d-flex flex-column pt-5"
    style="background-color: transparent; font-size: 14px"
    elevation="0"
  >
    <input
      @change="onFileUpload"
      type="file"
      id="upload"
      ref="theFile"
      style="display: none"
      accept="image/png, image/gif, image/jpeg"
    />

    <v-container>
      <v-row class="justify-center">
        <v-col cols="12" class="justify-center d-flex">
          <div @click="goToEditProfile" style="cursor: pointer">
            <v-badge bordered overlap icon="mdi-pencil" :color="site.color">
              <v-avatar size="60">
                <v-img
                  :lazy-src="customer.image"
                  :src="customer.image ? customer.image : defaultImage"
                  :key="customer.image"
                ></v-img>
              </v-avatar>
            </v-badge>
          </div>
        </v-col>
        <p class="white--text text-center">{{ $t("textProfile") }}</p>
      </v-row>
    </v-container>

    <v-row no-gutters>
      <v-col cols="12">
        <v-row no-gutters justify="center">
          <p
            class="text-caption font-weight-medium white--text mb-0 text-center"
          >
            {{ $t("code") }} : {{ customer.code }}
          </p>
        </v-row>
        <v-row no-gutters justify="center">
          <p
            class="text-body-2 white--text mb-0 font-weight-medium text-center"
          >
            {{ customer.name }}
            {{ customer.surname }}
          </p>
        </v-row>
        <v-row
          v-if="user_point_type == 'default_no_point'"
          no-gutters
          justify="center"
          align="center"
        >
          <div style="height: 24px"></div>
        </v-row>
        <v-row
          v-if="user_point_type == 'default'"
          no-gutters
          justify="center"
          align="center"
        >
          <div
            class="pa-0 mt-1 px-1"
            style="
              border-radius: 30px;
              background-color: beige;
              background: rgba(255, 255, 255, 0.12);
              border: 2px solid rgba(255, 255, 255, 0.25);
            "
            @click="goToMypoint('all')"
          >
            <div
              v-if="Array.isArray(customer.point) && customer.point.length > 0"
              class="d-flex align-center justify-center white--text"
              style="gap: 4px"
            >
              <PointSymbol
                :type="customer.point[0].point_type_type"
                :symbol="customer.point[0].point_type_symbol"
                :color="customer.point[0].point_type_color"
                :is_display="true"
                :outlined_box="false"
                :size="32"
              />
              <div style="font-size: 20px; font-weight: bold">
                {{ customer.point[0].point | commaPoint }}
              </div>
              <div style="font-size: 16px">
                {{ customer.point[0].point_type_name }}
              </div>
              <div>
                <v-icon color="white" small> mdi-chevron-right </v-icon>
              </div>
            </div>
          </div>
        </v-row>
      </v-col>
    </v-row>

    <v-row
      v-if="
        user_point_type == 'default' &&
        dataExpireCoin.site_use_expire == 'Y' &&
        Array.isArray(dataExpireCoin.total_expire_point) &&
        dataExpireCoin.total_expire_point.length > 0 &&
        dataExpireCoin.total_expire_point[0].point > 0 &&
        !checkDate(dataExpireCoin.point_expire_date)
      "
      justify="space-around"
      class="ma-2 mt-0"
      @click="goToMypoint('expiring')"
    >
      <v-col cols="12" class="d-flex justify-center px-1">
        <v-card elevation="2" color="white" dark class="px-4 py-2">
          <v-card-text class="black--text py-1">
            <v-row>
              <v-col cols="auto" align-self="center" style="padding: 0">
                <div class="mr-2">
                  <PointSymbol
                    :type="dataExpireCoin.total_expire_point[0].point_type_type"
                    :symbol="
                      dataExpireCoin.total_expire_point[0].point_type_symbol
                    "
                    :color="
                      dataExpireCoin.total_expire_point[0].point_type_color
                    "
                    :is_display="true"
                    :outlined_box="false"
                    :size="40"
                  />
                </div>
              </v-col>
              <v-col cols="auto" align-self="center">
                <v-row class="ma-0 align-center">
                  <h2 class="mr-1" :style="{ color: site.color }">
                    {{
                      dataExpireCoin.total_expire_point[0].point | commaPoint
                    }}
                  </h2>
                  <span>
                    {{ dataExpireCoin.total_expire_point[0].point_type_name }}
                  </span>
                </v-row>
                <v-row class="ma-0 align-center">
                  {{ $t("expiredAt") }}
                  {{ dataExpireCoin.point_expire_date | formatDate }}
                </v-row>
              </v-col>
              <v-icon color="grey" small style="margin-left: 10px">
                mdi-chevron-right
              </v-icon>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import moment from "moment";
import PointSymbol from "../point/point-symbol.vue";

export default {
  components: { PointSymbol },
  props: ["site", "customer", "url", "dataExpireCoin", "user_point_type"],
  computed: {
    defaultImage() {
      return require("@/assets/images/user.svg");
    },
  },

  methods: {
    onFileUpload(event) {
      this.$emit("onFileUpload", event);
    },
    goToEditProfile(event) {
      event.stopPropagation();
      this.$router.push({ name: "edit-profile" });
    },
    checkDate(date) {
      let dateMoreThan1Year = moment().add(1, "year").format("YYYY-MM-DD");
      console.log("dataExpireCoin :>> ", this.dataExpireCoin);
      console.log(
        "moment(date).isAfter(dateMoreThan1Year) :>> ",
        moment(date).isAfter(dateMoreThan1Year)
      );
      return moment(date).isAfter(dateMoreThan1Year);
    },
    goToMypoint(type) {
      this.$router.push({
        name: "my-point",
        query: { type },
      });
    },
  },
  filters: {
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("DD MMM YYYY");
    },
  },
};
</script>

<style scoped>
</style>
